// 상담 폼 관련 공통 유틸리티

// 고객명 입력 검증 (특수문자 및 공백 제거)
export function sanitizeCustomerName(value) {
  return value.replace(/\s/g, '').replace(/[/?.,;:|)*~`!^\-_+<>@#$%&\\=('"]/g, '');
}

// 연락처 입력 검증 (숫자만 허용)
export function sanitizeContact(value) {
  return value.replace(/\D/g, '');
}

// 연락처 유효성 검사
export function validatePhoneNumber(phone) {
  return phone.length >= 10 && phone.length <= 11;
}

// 기본 폼 검증 함수
export function validateConsultationForm(formData, fieldLabels = {}) {
  const {
    customerNameLabel = '이름',
    contactLabel = '연락처',
    regionLabel = '지역',
  } = fieldLabels;

  if (!formData.customerName.trim()) {
    alert(`${customerNameLabel}을(를) 입력해주세요.`);
    return false;
  }

  if (!formData.contact.trim()) {
    alert(`${contactLabel}을(를) 입력해주세요.`);
    return false;
  }

  if (!validatePhoneNumber(formData.contact)) {
    alert(`올바른 ${contactLabel}을(를) 입력해주세요.`);
    return false;
  }

  if (!formData.visitRegion) {
    alert(`${regionLabel}을(를) 선택해주세요.`);
    return false;
  }

  if (!formData.privacyConsent) {
    alert('개인정보 수집에 동의해주세요.');
    return false;
  }

  return true;
}

// 상담 예약 폼 데이터 초기화
export function getInitialFormData() {
  return {
    applicantType: '본인',
    customerName: '',
    contact: '',
    // 상담받을 매장 (매장찾기 데이터 한 줄: strCode, name, addr ...)
    store: null,
    hearingAidBrand: '포낙',
    privacyConsent: false
  };
}

// 공통 watch 설정을 위한 함수
export function setupFormWatchers(component) {
  return {
    'formData.customerName'(value) {
      const result = sanitizeCustomerName(value);
      component.$nextTick(() => {
        component.formData.customerName = result;
      });
    },
    'formData.contact'(value) {
      const result = sanitizeContact(value);
      component.$nextTick(() => {
        component.formData.contact = result;
      });
    }
  };
}
